import { api } from './client';
import type { AccountDto, CreateAccountRequest, UpdateAccountRequest } from '../types/account';
import type { AccountBalanceDto } from '../types/report';

export const accountsApi = {
  list: (params: { accountNumber?: number; limit?: number } = {}) =>
    api.get<AccountDto[]>('/accounts', {
      accountNumber: params.accountNumber,
      limit: params.limit ?? 200,
    }),

  getByNumber: (accountNumber: number) =>
    api.get<AccountDto>(`/accounts/${accountNumber}`),

  create: (data: CreateAccountRequest) =>
    api.post<number>('/accounts', data),

  update: (accountNumber: number, data: UpdateAccountRequest) =>
    api.put<void>(`/accounts/${accountNumber}`, data),

  delete: (accountNumber: number) =>
    api.delete<void>(`/accounts/${accountNumber}`),

  trialBalance: (params: { from: string; to: string; account?: number; nonZeroOnly?: boolean }) =>
    api.get<AccountBalanceDto[]>('/reports/trial-balance', {
      from: params.from,
      to: params.to,
      account: params.account,
      nonZeroOnly: params.nonZeroOnly ?? true,
    }),
};
